// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1HAk9","row":"ProcedureTreatmentSummary_row__2SV9G"};